<div class="dropdown-wrapper">
	<ng-select
		#input
		(keydown)="onKeyDown($event)"
		[items]="params.colDef.dropdownOptions"
		bindLabel="name"
		bindValue="id"
		appendTo="body"
		[formControl]="selectedOption"
		(change)="pushDropdownInput()"
		(click)="isDropdownOpened(true)"
		(blur)="isDropdownOpened(false)"
		[ngClass]="{ invalid: isInvalid(), 'hide-clear-icon': hideClearIcon() }"
	>
	</ng-select>
</div>
